"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CLICK_CODE = void 0;
/* eslint-disable max-lines */
/* eslint-disable max-lines */
exports.CLICK_CODE = {
    /**
    * @desc 취소한 내역 보기 페이지
    * @tag Mplace.placemy | 타임라인 페이지 취소내역
    */
    'canceledtimelinepg': 'canceledtimelinepg',
    /**
    * @desc 뒤로가기
    * @tag Mplace.placemy | 타임라인 페이지 취소내역
    */
    'canceledtimelinepg.back': 'canceledtimelinepg.back',
    /**
    * @desc 다시 예약 버튼
    * @tag Mplace.placemy | 타임라인 페이지 취소내역
    * @memo rank: ?, 장소의 순번에 해당하는 숫자 함께 로깅
    */
    'canceledtimelinepg.book': 'canceledtimelinepg.book',
    /**
    * @desc 취소 예약 리스트 선택
    * @tag Mplace.placemy | 타임라인 페이지 취소내역
    */
    'canceledtimelinepg.bookinglist': 'canceledtimelinepg.bookinglist',
    /**
    * @desc 나가기
    * @tag Mplace.placemy | 타임라인 페이지 취소내역
    */
    'canceledtimelinepg.close': 'canceledtimelinepg.close',
    /**
    * @desc 다시 주문 버튼
    * @tag Mplace.placemy | 타임라인 페이지 취소내역
    */
    'canceledtimelinepg.order': 'canceledtimelinepg.order',
    /**
    * @desc 취소 주문 리스트 선택
    * @tag Mplace.placemy | 타임라인 페이지 취소내역
    * @memo rank: 10, 리스트가 속한 장소의 순번에 해당하는 숫자 함께 로깅
    */
    'canceledtimelinepg.orderlist': 'canceledtimelinepg.orderlist',
    /**
    * @desc 탭 (예약)
    * @tag Mplace.placemy | 타임라인 페이지 취소내역
    */
    'canceledtimelinepg.tapbooking': 'canceledtimelinepg.tapbooking',
    /**
    * @desc 탭 (주문)
    * @tag Mplace.placemy | 타임라인 페이지 취소내역
    */
    'canceledtimelinepg.taporder': 'canceledtimelinepg.taporder',
    /**
    * @desc 탭 (승차권)
    * @tag Mplace.placemy | 타임라인 페이지 취소내역
    */
    'canceledtimelinepg.taptrainticket': 'canceledtimelinepg.taptrainticket',
    /**
    * @desc 기차 예매 버튼
    * @tag Mplace.placemy | 타임라인 페이지 취소내역
    */
    'canceledtimelinepg.train': 'canceledtimelinepg.train',
    /**
    * @desc 취소 승차권 리스트 선택
    * @tag Mplace.placemy | 타임라인 페이지 취소내역
    * @memo rank: 10, 장소의 순번에 해당하는 숫자 함께 로깅
    */
    'canceledtimelinepg.trainticketlist': 'canceledtimelinepg.trainticketlist',
    /**
    * @desc 마이플레이스로고
    * @tag 헤더 | Mplace.placemy | MY홈
    */
    'gnb.myplace': 'gnb.myplace',
    /**
    * @desc 내 리뷰 선택
    * @tag 프로필 | Mplace.placemy | MY홈
    */
    'gnb.myprofilereview': 'gnb.myprofilereview',
    /**
    * @desc naver로고
    * @tag 헤더 | Mplace.placemy | MY홈
    */
    'gnb.navermain': 'gnb.navermain',
    /**
    * @desc 프로필 수정
    * @tag 프로필 | Mplace.placemy | MY홈
    */
    'gnb.profile': 'gnb.profile',
    /**
    * @desc 웹설정
    * @tag 헤더 | Mplace.placemy | MY홈
    */
    'gnb.settings': 'gnb.settings',
    /**
    * @desc 오늘방문 > 현위치 수신/재탐색
    * @tag Mplace.placemy | 데일리 브리핑 | MY홈
    */
    'lils.dailybriefingnow': 'lils.dailybriefingnow',
    /**
    * @desc 장소요약카드뷰>현위치(장소로깅)
    * @tag Mplace.placemy | 타임라인 페이지 장소요약
    */
    'lils.placecardmapnow': 'lils.placecardmapnow',
    /**
    * @desc 타임라인 > 지도뷰 현위치지도 호출
    * @tag Mplace.placemy | MY홈 | 타임라인 지도뷰
    */
    'lils.timelinemapnow_emptycase': 'lils.timelinemapnow_emptycase',
    /**
    * @desc 타임라인 > 지도뷰 현위치지도 호출
    * @tag Mplace.placemy | MY홈 | 타임라인 지도뷰
    */
    'lils.timelinemapnowemptycase': 'lils.timelinemapnowemptycase',
    /**
    * @desc 타임라인 > 현위치 수신
    * @tag 타임라인 페이지 지도뷰 | Mplace.placemy
    */
    'lils.timelinepgmapnow': 'lils.timelinepgmapnow',
    /**
    * @desc 미션 참여시 카드 클릭
    * @tag Mplace.placemy | 미션 | MY홈
    */
    'my.missioncard': 'my.missioncard',
    /**
    * @desc 미션 미참여
    * @tag Mplace.placemy | 미션 | MY홈
    */
    'my.missionempty': 'my.missionempty',
    /**
    * @desc 미션 미참여시 카드 클릭
    * @tag Mplace.placemy | 미션 | MY홈
    */
    'my.missionemptycard': 'my.missionemptycard',
    /**
    * @desc 미션 미참여시 더보기
    * @tag Mplace.placemy | 미션 | MY홈
    */
    'my.missionemptymore': 'my.missionemptymore',
    /**
    * @desc 미션 미참여시 카드 스와이프
    * @tag Mplace.placemy | 미션 | MY홈
    */
    'my.missionemptyswipe': 'my.missionemptyswipe',
    /**
    * @desc 미션 미참여시 타이틀 클릭
    * @tag Mplace.placemy | 미션 | MY홈
    */
    'my.missionemptytitle': 'my.missionemptytitle',
    /**
    * @desc 미션 참여시 더보기
    * @tag Mplace.placemy | 미션 | MY홈
    */
    'my.missionmore': 'my.missionmore',
    /**
    * @desc 미션 참여시 카드 스와이프
    * @tag Mplace.placemy | 미션 | MY홈
    */
    'my.missionswipe': 'my.missionswipe',
    /**
    * @desc 미션 참여시 타이틀 클릭
    * @tag Mplace.placemy | 미션 | MY홈
    */
    'my.missiontitle': 'my.missiontitle',
    /**
    * @desc 페이지 새로고침 (Pull to Refresh)
    * @tag Mplace.placemy | MY홈
    */
    'my.pagereload': 'my.pagereload',
    /**
    * @desc 리뷰쓰기 버튼 (Full)
    * @tag 리뷰쓰기 | Mplace.placemy | MY홈
    */
    'my.reviewwritebttn': 'my.reviewwritebttn',
    /**
    * @desc 리뷰쓰기 버튼 (축약형)
    * @tag 리뷰쓰기 | Mplace.placemy | MY홈
    */
    'my.reviewwriteiconbttn': 'my.reviewwriteiconbttn',
    /**
    * @desc 숏컷 > 예약
    * @tag 숏컷 | Mplace.placemy | MY홈
    */
    'my.shortcutbooking': 'my.shortcutbooking',
    /**
    * @desc 숏컷 > 저장
    * @tag 숏컷 | Mplace.placemy | MY홈
    */
    'my.shortcutbookmark': 'my.shortcutbookmark',
    /**
    * @desc 숏컷 > 쿠폰
    * @tag 숏컷 | Mplace.placemy | MY홈
    */
    'my.shortcutcoupon': 'my.shortcutcoupon',
    /**
    * @desc 숏컷 > 주문
    * @tag 숏컷 | Mplace.placemy | MY홈
    */
    'my.shortcutorder': 'my.shortcutorder',
    /**
    * @desc 숏컷 > 내 리뷰
    * @tag 숏컷 | Mplace.placemy | MY홈
    */
    'my.shortcutreviewmy': 'my.shortcutreviewmy',
    /**
    * @desc 탑 버튼
    * @tag Mplace.placemy | MY홈
    */
    'my.topbttn': 'my.topbttn',
    /**
    * @desc 예약배너
    * @tag 예약특화 배너 | Mplace.placemy | MY홈
    */
    'mybookingbanner': 'mybookingbanner',
    /**
    * @desc 예약배너>배너선택
    * @tag 예약특화 배너 | Mplace.placemy | MY홈
    */
    'mybookingbanner.banner': 'mybookingbanner.banner',
    /**
    * @desc 예약트렌드픽
    * @tag 예약특화 트렌드픽 | Mplace.placemy | MY홈
    */
    'mybookingtrendpick': 'mybookingtrendpick',
    /**
    * @desc 예약트렌드픽>숏컷선택
    * @tag 예약특화 트렌드픽 | Mplace.placemy | MY홈
    */
    'mybookingtrendpick.shortcuts': 'mybookingtrendpick.shortcuts',
    /**
    * @desc 캘린더 섹션 표출
    * @tag 캘린더 | Mplace.placemy | MY홈
    */
    'mycalendar': 'mycalendar',
    /**
    * @desc 내역 선택
    * @tag 캘린더 | Mplace.placemy | MY홈
    */
    'mycalendar.detailsclick': 'mycalendar.detailsclick',
    /**
    * @desc 전월 버튼
    * @tag 캘린더 | Mplace.placemy | MY홈
    */
    'mycalendar.lastmonth': 'mycalendar.lastmonth',
    /**
    * @desc 익월 버튼
    * @tag 캘린더 | Mplace.placemy | MY홈
    */
    'mycalendar.nextmonth': 'mycalendar.nextmonth',
    /**
    * @desc 오늘방문
    * @tag Mplace.placemy | 데일리 브리핑 | MY홈
    */
    'mydaily': 'mydaily',
    /**
    * @desc 오늘방문 > 전화
    * @tag Mplace.placemy | 데일리 브리핑 | MY홈
    */
    'mydaily.call': 'mydaily.call',
    /**
    * @desc 자동차 길찾기
    * @tag Mplace.placemy | 데일리 브리핑 | MY홈
    */
    'mydaily.navigation': 'mydaily.navigation',
    /**
    * @desc 오늘방문 > 다른장소
    * @tag Mplace.placemy | 데일리 브리핑 | MY홈
    */
    'mydaily.otherplace': 'mydaily.otherplace',
    /**
    * @desc 장소 보기
    * @tag Mplace.placemy | 데일리 브리핑 | MY홈
    */
    'mydaily.poi': 'mydaily.poi',
    /**
    * @desc 대중교통 길찾기
    * @tag Mplace.placemy | 데일리 브리핑 | MY홈
    */
    'mydaily.pubtrans': 'mydaily.pubtrans',
    /**
    * @desc 새로고침
    * @tag Mplace.placemy | 데일리 브리핑 | MY홈
    */
    'mydaily.reload': 'mydaily.reload',
    /**
    * @desc 리뷰쓰기
    * @tag Mplace.placemy | 데일리 브리핑 | MY홈
    */
    'mydaily.reviewrite': 'mydaily.reviewrite',
    /**
    * @desc 오늘방문 > 장소 저장 추가
    * @tag Mplace.placemy | 데일리 브리핑 | MY홈
    */
    'mydaily.save': 'mydaily.save',
    /**
    * @desc 오늘방문 > 장소 저장 해제
    * @tag Mplace.placemy | 데일리 브리핑 | MY홈
    */
    'mydaily.unsave': 'mydaily.unsave',
    /**
    * @desc MY Driving
    * @tag Mplace.placemy | 지도특화 MY Driving | MY홈
    * @memo rank: 15
    */
    'mydriving': 'mydriving',
    /**
    * @desc 차량정보
    * @tag Mplace.placemy | 지도특화 MY Driving | MY홈
    * @memo rank: 15
    */
    'mydriving.carinfo': 'mydriving.carinfo',
    /**
    * @desc (미연동) 내 차량 설정하기
    * @tag Mplace.placemy | 지도특화 MY Driving | MY홈
    */
    'mydriving.carsetting': 'mydriving.carsetting',
    /**
    * @desc New 보험사 툴팁 닫기
    * @tag Myplace.placemy | 지도특화 MY Driving | MY홈
    * @memo 툴팁 미노출
    */
    'mydriving.closeinsuttip': 'mydriving.closeinsuttip',
    /**
    * @desc 보험 할인 정보 버튼
    * @tag Mplace.placemy | 지도특화 MY Driving | MY홈
    */
    'mydriving.insubttn': 'mydriving.insubttn',
    /**
    * @desc 차량정보 > MYCAR
    * @tag Mplace.placemy | 지도특화 MY Driving | MY홈
    * @memo rank: 15
    */
    'mydriving.mycar': 'mydriving.mycar',
    /**
    * @desc New 보험사 툴팁
    * @tag Mplace.placemy | MY홈 | MY Driving | 지도특화
    * @memo 운전분석 > 보험카드 위치로 랜딩
    */
    'mydriving.newinsuttip': 'mydriving.newinsuttip',
    /**
    * @desc 내 주행이력
    * @tag Mplace.placemy | 지도특화 MY Driving | MY홈
    */
    'mydriving.record': 'mydriving.record',
    /**
    * @desc 내 운전점수
    * @tag Mplace.placemy | 지도특화 MY Driving | MY홈
    */
    'mydriving.score': 'mydriving.score',
    /**
    * @desc 운전점수 시작
    * @tag Mplace.placemy | 지도특화 MY Driving | MY홈
    */
    'mydriving.scorestart': 'mydriving.scorestart',
    /**
    * @desc 즐겨찾기
    * @tag Mplace.placemy | MY홈 | 지도특화 즐겨찾기
    */
    'myfavplace': 'myfavplace',
    /**
    * @desc 자주가는 장소(등록전)
    * @tag Mplace.placemy | MY홈 | 지도특화 즐겨찾기
    */
    'myfavplace.addfavorite': 'myfavplace.addfavorite',
    /**
    * @desc 집(등록전)
    * @tag Mplace.placemy | MY홈 | 지도특화 즐겨찾기
    * @memo rank: 10
    */
    'myfavplace.addhome': 'myfavplace.addhome',
    /**
    * @desc 회사/학교(등록전)
    * @tag Mplace.placemy | MY홈 | 지도특화 즐겨찾기
    */
    'myfavplace.addofficeschool': 'myfavplace.addofficeschool',
    /**
    * @desc 자주가는장소
    * @tag Mplace.placemy | MY홈 | 지도특화 즐겨찾기
    * @memo rank: 10
    */
    'myfavplace.favorite': 'myfavplace.favorite',
    /**
    * @desc 집
    * @tag Mplace.placemy | MY홈 | 지도특화 즐겨찾기
    * @memo rank: 20
    */
    'myfavplace.home': 'myfavplace.home',
    /**
    * @desc 회사
    * @tag Mplace.placemy | MY홈 | 지도특화 즐겨찾기
    * @memo rank: 20
    */
    'myfavplace.office': 'myfavplace.office',
    /**
    * @desc 학교
    * @tag Mplace.placemy | MY홈 | 지도특화 즐겨찾기
    */
    'myfavplace.school': 'myfavplace.school',
    /**
    * @desc 즐겨찾기 타이틀
    * @tag Mplace.placemy | MY홈 | 지도특화 즐겨찾기
    */
    'myfavplace.title': 'myfavplace.title',
    /**
    * @desc 리뷰특화_팔로잉리뷰
    * @tag 리뷰특화 팔로잉리뷰 | Mplace.placemy | MY홈
    * @memo rank: 8
    */
    'myfollowing': 'myfollowing',
    /**
    * @desc 리뷰특화_팔로잉리뷰 >카드
    * @tag 리뷰특화 팔로잉리뷰 | Mplace.placemy | MY홈
    */
    'myfollowing.card': 'myfollowing.card',
    /**
    * @desc 리뷰특화_팔로잉리뷰 >프로필
    * @tag 리뷰특화 팔로잉리뷰 | Mplace.placemy | MY홈
    */
    'myfollowing.profile': 'myfollowing.profile',
    /**
    * @desc 푸터
    * @tag 푸터 | Mplace.placemy | MY홈
    */
    'myfooter': 'myfooter',
    /**
    * @desc 전체서비스
    * @tag 푸터 | Mplace.placemy | MY홈
    */
    'myfooter.allservices': 'myfooter.allservices',
    /**
    * @desc 네이버 예약 고객센터
    * @tag 푸터 | Mplace.placemy | MY홈
    */
    'myfooter.customerserviceforbooking': 'myfooter.customerserviceforbooking',
    /**
    * @desc MY플레이스 고객센터
    * @tag 푸터 | Mplace.placemy | MY홈
    */
    'myfooter.customerserviceformyplace': 'myfooter.customerserviceformyplace',
    /**
    * @desc 사업자정보 펼치기
    * @tag 푸터 | Mplace.placemy | MY홈
    */
    'myfooter.formoreinformation': 'myfooter.formoreinformation',
    /**
    * @desc 로그인
    * @tag 푸터 | Mplace.placemy | MY홈
    */
    'myfooter.login': 'myfooter.login',
    /**
    * @desc 로그아웃
    * @tag 푸터 | Mplace.placemy | MY홈
    */
    'myfooter.logout': 'myfooter.logout',
    /**
    * @desc 개인정보처리방침
    * @tag 푸터 | Mplace.placemy | MY홈
    */
    'myfooter.privacypolicy': 'myfooter.privacypolicy',
    /**
    * @desc 네이버 예약 이용약관
    * @tag 푸터 | Mplace.placemy | MY홈
    */
    'myfooter.termsofserviceforbooking': 'myfooter.termsofserviceforbooking',
    /**
    * @desc 네이버 지도 서비스 이용약관
    * @tag 푸터 | Mplace.placemy | MY홈
    */
    'myfooter.termsofserviceformap': 'myfooter.termsofserviceformap',
    /**
    * @desc 플레이스 리뷰 이용정책
    * @tag 푸터 | Mplace.placemy | MY홈
    */
    'myfooter.termsofserviceforplacereview': 'myfooter.termsofserviceforplacereview',
    /**
    * @desc 자주찾는주문예약
    * @tag Mplace.placemy | 예약특화 자주찾는주문예약 | MY홈
    */
    'myfrequent': 'myfrequent',
    /**
    * @desc 자주찾는주문예약>예약하기
    * @tag Mplace.placemy | 예약특화 자주찾는주문예약 | MY홈
    */
    'myfrequent.book': 'myfrequent.book',
    /**
    * @desc 자주찾는주문예약>예약카드
    * @tag Mplace.placemy | 예약특화 자주찾는주문예약 | MY홈
    */
    'myfrequent.bookingcard': 'myfrequent.bookingcard',
    /**
    * @desc 자주찾는주문예약>예약탭
    * @tag Mplace.placemy | 예약특화 자주찾는주문예약 | MY홈
    */
    'myfrequent.bookingtab': 'myfrequent.bookingtab',
    /**
    * @desc 자주찾는주문예약>주문하기
    * @tag Mplace.placemy | 예약특화 자주찾는주문예약 | MY홈
    */
    'myfrequent.order': 'myfrequent.order',
    /**
    * @desc 자주찾는주문예약>주문카드
    * @tag Mplace.placemy | 예약특화 자주찾는주문예약 | MY홈
    */
    'myfrequent.ordercard': 'myfrequent.ordercard',
    /**
    * @desc 자주찾는주문예약>근처주문업체
    * @tag Mplace.placemy | 예약특화 자주찾는주문예약 | MY홈
    */
    'myfrequent.ordernearby': 'myfrequent.ordernearby',
    /**
    * @desc 자주찾는주문예약>주문탭
    * @tag Mplace.placemy | 예약특화 자주찾는주문예약 | MY홈
    */
    'myfrequent.ordertab': 'myfrequent.ordertab',
    /**
    * @desc 자주찾는주문예약>스탬프보기
    * @tag Mplace.placemy | 예약특화 자주찾는주문예약 | MY홈
    */
    'myfrequent.stamp': 'myfrequent.stamp',
    /**
    * @desc 리뷰 조회수
    * @tag 통계 리뷰조회수 | Mplace.placemy | MY홈
    */
    'myinfluencereviewviews': 'myinfluencereviewviews',
    /**
    * @desc 최근인기있는내리뷰 클릭
    * @tag 통계 리뷰조회수 | Mplace.placemy | MY홈
    */
    'myinfluencereviewviews.click': 'myinfluencereviewviews.click',
    /**
    * @desc 최근인기있는내리뷰 더보기 클릭
    * @tag 통계 리뷰조회수 | Mplace.placemy | MY홈
    */
    'myinfluencereviewviews.more': 'myinfluencereviewviews.more',
    /**
    * @desc 리뷰 조회수 랭킹 확인
    * @tag 통계 리뷰조회수 | Mplace.placemy | MY홈
    */
    'myinfluencereviewviews.rank': 'myinfluencereviewviews.rank',
    /**
    * @desc 최근저장한장소
    * @tag 지도특화 최근저장장소 | Mplace.placemy | MY홈
    */
    'mylatestbmk': 'mylatestbmk',
    /**
    * @desc 저장 리스트 홈
    * @tag 지도특화 최근저장장소 | Mplace.placemy | MY홈
    */
    'mylatestbmk.bmklist': 'mylatestbmk.bmklist',
    /**
    * @desc 저장한장소
    * @tag 지도특화 최근저장장소 | Mplace.placemy | MY홈
    */
    'mylatestbmk.bmkplace': 'mylatestbmk.bmkplace',
    /**
    * @desc 내 장소 (디폴트) 리스트
    * @tag 지도특화 최근저장장소 | Mplace.placemy | MY홈
    */
    'mylatestbmk.defautllist': 'mylatestbmk.defautllist',
    /**
    * @desc 더보기
    * @tag 지도특화 최근저장장소 | Mplace.placemy | MY홈
    * @memo rank: 15
    */
    'mylatestbmk.morebmk': 'mylatestbmk.morebmk',
    /**
    * @desc 내 리스트
    * @tag 지도특화 최근저장장소 | Mplace.placemy | MY홈
    */
    'mylatestbmk.mylist': 'mylatestbmk.mylist',
    /**
    * @desc 미션
    * @tag 리뷰특화 미션 | Mplace.placemy | MY홈
    */
    'mymission': 'mymission',
    /**
    * @desc 미션 참여시 카드 클릭
    * @tag 리뷰특화 미션 | Mplace.placemy | MY홈
    */
    'mymission.card': 'mymission.card',
    /**
    * @desc 미션 미참여
    * @tag 리뷰특화 미션 | Mplace.placemy | MY홈
    */
    'mymission.empty': 'mymission.empty',
    /**
    * @desc 미션 미참여시 카드 클릭
    * @tag 리뷰특화 미션 | Mplace.placemy | MY홈
    */
    'mymission.emptycard': 'mymission.emptycard',
    /**
    * @desc 미션 미참여시 더보기
    * @tag 리뷰특화 미션 | Mplace.placemy | MY홈
    */
    'mymission.emptymore': 'mymission.emptymore',
    /**
    * @desc 미션 미참여시 타이틀 클릭
    * @tag 리뷰특화 미션 | Mplace.placemy | MY홈
    */
    'mymission.emptytitle': 'mymission.emptytitle',
    /**
    * @desc 미션 참여시 더보기
    * @tag 리뷰특화 미션 | Mplace.placemy | MY홈
    */
    'mymission.more': 'mymission.more',
    /**
    * @desc 미션 참여시 타이틀 클릭
    * @tag 리뷰특화 미션 | Mplace.placemy | MY홈
    */
    'mymission.title': 'mymission.title',
    /**
    * @desc 추천 업체
    * @tag D-day추천 | Mplace.placemy | MY홈
    */
    'mynearbyrecommendations': 'mynearbyrecommendations',
    /**
    * @desc 추천 업체 카드
    * @tag D-day추천 | Mplace.placemy | MY홈
    */
    'mynearbyrecommendations.card': 'mynearbyrecommendations.card',
    /**
    * @desc 타임라인
    * @tag 타임라인 리스트 | Mplace.placemy | MY홈 | 타임라인 지도뷰
    */
    'mytimeline': 'mytimeline',
    /**
    * @desc 전체 내역 보기
    * @tag 타임라인 리스트 | Mplace.placemy | MY홈
    */
    'mytimeline.allactivity': 'mytimeline.allactivity',
    /**
    * @desc 체크인 버튼
    * @tag 타임라인 리스트 | Mplace.placemy | MY홈
    */
    'mytimeline.checkin': 'mytimeline.checkin',
    /**
    * @desc 리스트 선택
    * @tag 타임라인 리스트 | Mplace.placemy | MY홈
    */
    'mytimeline.list': 'mytimeline.list',
    /**
    * @desc 타임라인 > 지도뷰
    * @tag Mplace.placemy | MY홈 | 타임라인 지도뷰
    */
    'mytimeline.map': 'mytimeline.map',
    /**
    * @desc 내리뷰 버튼
    * @tag 타임라인 리스트 | Mplace.placemy | MY홈
    */
    'mytimeline.reviewfeedmy': 'mytimeline.reviewfeedmy',
    /**
    * @desc 리뷰쓰기 버튼
    * @tag 타임라인 리스트 | Mplace.placemy | MY홈
    */
    'mytimeline.reviewwrite': 'mytimeline.reviewwrite',
    /**
    * @desc 장소 저장 추가
    * @tag 타임라인 리스트 | Mplace.placemy | MY홈
    */
    'mytimeline.save': 'mytimeline.save',
    /**
    * @desc 타임라인 > 상세
    * @tag Mplace.placemy | MY홈 | 타임라인 지도뷰
    */
    'mytimeline.title': 'mytimeline.title',
    /**
    * @desc 장소 저장 해제
    * @tag 타임라인 리스트 | Mplace.placemy | MY홈
    */
    'mytimeline.unsave': 'mytimeline.unsave',
    /**
    * @desc 리뷰특화_미작성리뷰넛지
    * @tag Mplace.placemy | MY홈 | 리뷰특화 미작성리뷰넛지
    */
    'myunwritten': 'myunwritten',
    /**
    * @desc 리뷰특화_미작성리뷰넛지>숨기기
    * @tag Mplace.placemy | MY홈 | 리뷰특화 미작성리뷰넛지
    */
    'myunwritten.hide': 'myunwritten.hide',
    /**
    * @desc 리뷰특화_미작성리뷰넛지>숨기기취소
    * @tag Mplace.placemy | MY홈 | 리뷰특화 미작성리뷰넛지
    */
    'myunwritten.hidecancel': 'myunwritten.hidecancel',
    /**
    * @desc 리뷰특화_미작성리뷰넛지>숨기기확인
    * @tag Mplace.placemy | MY홈 | 리뷰특화 미작성리뷰넛지
    */
    'myunwritten.hideok': 'myunwritten.hideok',
    /**
    * @desc 리뷰특화_미작성리뷰넛지>방문목록
    * @tag Mplace.placemy | MY홈 | 리뷰특화 미작성리뷰넛지
    */
    'myunwritten.list': 'myunwritten.list',
    /**
    * @desc 리뷰특화_미작성리뷰넛지>리뷰쓰기
    * @tag Mplace.placemy | MY홈 | 리뷰특화 미작성리뷰넛지
    */
    'myunwritten.write': 'myunwritten.write',
    /**
    * @desc 업커밍 섹션
    * @tag Mplace.placemy | 업커밍 | MY홈
    */
    'myupcoming': 'myupcoming',
    /**
    * @desc 업커밍 유형칩 (전체)
    * @tag Mplace.placemy | 업커밍 | MY홈
    */
    'myupcoming.allchip': 'myupcoming.allchip',
    /**
    * @desc 업커밍 유형칩 (예약)
    * @tag Mplace.placemy | 업커밍 | MY홈
    */
    'myupcoming.bookingchip': 'myupcoming.bookingchip',
    /**
    * @desc 예약 내역
    * @tag Mplace.placemy | 업커밍 | MY홈
    */
    'myupcoming.bookingdetails': 'myupcoming.bookingdetails',
    /**
    * @desc 업커밍 카드
    * @tag Mplace.placemy | 업커밍 | MY홈
    */
    'myupcoming.card': 'myupcoming.card',
    /**
    * @desc 새로고침
    * @tag Mplace.placemy | 업커밍 | MY홈
    */
    'myupcoming.cardrefresh': 'myupcoming.cardrefresh',
    /**
    * @desc 길찾기
    * @tag Mplace.placemy | 업커밍 | MY홈
    */
    'myupcoming.direction': 'myupcoming.direction',
    /**
    * @desc 길찾기
    * @tag Mplace.placemy | 업커밍 | MY홈
    */
    'myupcoming.directionicon': 'myupcoming.directionicon',
    /**
    * @desc 더보기
    * @tag Mplace.placemy | 업커밍 | MY홈
    * @memo rank: 10
    */
    'myupcoming.more': 'myupcoming.more',
    /**
    * @desc 더보기(전체)
    * @tag Mplace.placemy | 업커밍 | MY홈
    */
    'myupcoming.moreall': 'myupcoming.moreall',
    /**
    * @desc 더보기(예약)
    * @tag Mplace.placemy | 업커밍 | MY홈
    */
    'myupcoming.morebooking': 'myupcoming.morebooking',
    /**
    * @desc 더보기(주문)
    * @tag Mplace.placemy | 업커밍 | MY홈
    */
    'myupcoming.moreorder': 'myupcoming.moreorder',
    /**
    * @desc 더보기(승차권)
    * @tag Mplace.placemy | 업커밍 | MY홈
    */
    'myupcoming.moretrainticket': 'myupcoming.moretrainticket',
    /**
    * @desc 업커밍 유형칩 (주문)
    * @tag Mplace.placemy | 업커밍 | MY홈
    * @memo rank: 10
    */
    'myupcoming.orderchip': 'myupcoming.orderchip',
    /**
    * @desc 업커밍 섹션(타이틀) >
    * @tag Mplace.placemy | 업커밍 | MY홈
    */
    'myupcoming.title': 'myupcoming.title',
    /**
    * @desc 업커밍 유형칩 (승차권)
    * @tag Mplace.placemy | 업커밍 | MY홈
    */
    'myupcoming.trainticketchip': 'myupcoming.trainticketchip',
    /**
    * @desc 빈자리알림
    * @tag Mplace.placemy | MY홈 | 빈자리 알림
    */
    'myvacancyalert': 'myvacancyalert',
    /**
    * @desc 빈자리알림>보기
    * @tag Mplace.placemy | MY홈 | 빈자리 알림
    */
    'myvacancyalert.detail': 'myvacancyalert.detail',
    /**
    * @desc 리뷰탭_타인뷰
    * @tag Mplace.placemy | 리뷰특화 타인뷰
    */
    'otherreviewtab': 'otherreviewtab',
    /**
    * @desc 타인뷰_닫기
    * @tag Mplace.placemy | 리뷰특화 타인뷰
    */
    'otherreviewtab.close': 'otherreviewtab.close',
    /**
    * @desc 타인뷰_네이버메인으로이동
    * @tag Mplace.placemy | 리뷰특화 타인뷰
    */
    'otherreviewtab.navermain': 'otherreviewtab.navermain',
    /**
    * @desc 타인뷰_리뷰참여
    * @tag Mplace.placemy | 리뷰특화 타인뷰
    */
    'otherreviewtab.reviewwrite': 'otherreviewtab.reviewwrite',
    /**
    * @desc 장소요약카드뷰
    * @tag Mplace.placemy | 타임라인 페이지 장소요약
    */
    'placecard': 'placecard',
    /**
    * @desc 장소요약카드뷰>뒤로가기
    * @tag Mplace.placemy | 타임라인 페이지 장소요약
    */
    'placecard.back': 'placecard.back',
    /**
    * @desc 장소요약카드뷰> 전화
    * @tag Mplace.placemy | 타임라인 페이지 장소요약
    */
    'placecard.call': 'placecard.call',
    /**
    * @desc 장소요약카드뷰>X
    * @tag Mplace.placemy | 타임라인 페이지 장소요약
    * @memo rank: 5
    */
    'placecard.cancel': 'placecard.cancel',
    /**
    * @desc 장소요약카드뷰> 길찾기
    * @tag Mplace.placemy | 타임라인 페이지 장소요약
    */
    'placecard.direction': 'placecard.direction',
    /**
    * @desc 장소요약카드뷰>현위치
    * @tag Mplace.placemy | 타임라인 페이지 장소요약
    */
    'placecard.mylocation': 'placecard.mylocation',
    /**
    * @desc 장소요약카드뷰> 주문내역
    * @tag Mplace.placemy | 타임라인 페이지 장소요약
    * @memo rank: 5
    */
    'placecard.orderdetails': 'placecard.orderdetails',
    /**
    * @desc 장소요약카드뷰> 장소상세
    * @tag Mplace.placemy | 타임라인 페이지 장소요약
    */
    'placecard.placedesc': 'placecard.placedesc',
    /**
    * @desc 장소요약카드뷰> 예약내역
    * @tag Mplace.placemy | 타임라인 페이지 장소요약
    */
    'placecard.rsvdetails': 'placecard.rsvdetails',
    /**
    * @desc 장소요약카드뷰> 확인중인예약
    * @tag Mplace.placemy | 타임라인 페이지 장소요약
    */
    'placecard.rsvdetails_confirming': 'placecard.rsvdetails_confirming',
    /**
    * @desc 장소요약카드뷰> 확인중인예약
    * @tag Mplace.placemy | 타임라인 페이지 장소요약
    */
    'placecard.rsvdetailsconfirming': 'placecard.rsvdetailsconfirming',
    /**
    * @desc 장소요약카드뷰> 저장 추가
    * @tag Mplace.placemy | 타임라인 페이지 장소요약
    */
    'placecard.save': 'placecard.save',
    /**
    * @desc 장소요약카드뷰> 공유
    * @tag Mplace.placemy | 타임라인 페이지 장소요약
    */
    'placecard.share': 'placecard.share',
    /**
    * @desc 장소요약카드뷰> 저장 해제
    * @tag Mplace.placemy | 타임라인 페이지 장소요약
    */
    'placecard.unsave': 'placecard.unsave',
    /**
    * @desc 장소요약카드뷰> 저장 리스트
    * @tag Mplace.placemy | 타임라인 페이지 장소요약
    */
    'placecard.viewlist': 'placecard.viewlist',
    /**
    * @desc 리작완 클립 배너
    * @tag 리작완 | Mplace.placemy
    */
    'reviewdone.clip': 'reviewdone.clip',
    /**
    * @desc 리작완 클립 도움말
    * @tag 리작완 | Mplace.placemy
    */
    'reviewdone.cliptip': 'reviewdone.cliptip',
    /**
    * @desc 리작완 클립 도움말 닫기
    * @tag 리작완 | Mplace.placemy
    */
    'reviewdone.cliptipx': 'reviewdone.cliptipx',
    /**
    * @desc 장소 추천 - 호텔 / 개별 이미지
    */
    'reviewdone.hotel': 'reviewdone.hotel',
    /**
    * @desc 장소 추천 - 호텔 / 더보기 (리프레시)
    */
    'reviewdone.hotelref': 'reviewdone.hotelref',
    /**
    * @desc 호텔 리뷰 이어쓰기
    */
    'reviewdone.hotelreviewwrite1': 'reviewdone.hotelreviewwrite1',
    /**
    * @desc 장소 추천 - 해외 명소 / 개별 이미지
    */
    'reviewdone.overseas': 'reviewdone.overseas',
    /**
    * @desc 장소 추천 - 해외 명소 / 더보기 (리프레시)
    */
    'reviewdone.overseasref': 'reviewdone.overseasref',
    /**
    * @desc 리뷰탭_본인뷰
    * @tag 리뷰특화 본인뷰 | Mplace.placemy
    */
    'reviewtab': 'reviewtab',
    /**
    * @desc 본인뷰_닫기
    * @tag 리뷰특화 본인뷰 | Mplace.placemy
    */
    'reviewtab.close': 'reviewtab.close',
    /**
    * @desc 본인뷰_미션
    * @tag 리뷰특화 본인뷰 | Mplace.placemy
    */
    'reviewtab.mission': 'reviewtab.mission',
    /**
    * @desc 본인뷰_네이버메인으로이동
    * @tag 리뷰특화 본인뷰 | Mplace.placemy
    */
    'reviewtab.navermain': 'reviewtab.navermain',
    /**
    * @desc 본인뷰_공유하기
    * @tag 리뷰특화 본인뷰 | Mplace.placemy
    */
    'reviewtab.sharebttn': 'reviewtab.sharebttn',
    /**
    * @desc MY 설정 페이지 (웹)
    * @tag Mplace.placemy | 설정
    */
    'settings': 'settings',
    /**
    * @desc MY 설정> 네이버 예약/주문 알림
    * @tag Mplace.placemy | 설정
    */
    'settings.alertbookingorder': 'settings.alertbookingorder',
    /**
    * @desc MY 설정> MY플레이스 알림
    * @tag Mplace.placemy | 설정
    */
    'settings.alertmyplace': 'settings.alertmyplace',
    /**
    * @desc MY 설정> 예약/주문 자동결제 관리
    * @tag Mplace.placemy | 설정
    */
    'settings.autopaybookingorder': 'settings.autopaybookingorder',
    /**
    * @desc MY 설정> 네이버 예약/주문 공식 블로그
    * @tag Mplace.placemy | 설정
    */
    'settings.blogbookingorder': 'settings.blogbookingorder',
    /**
    * @desc MY 설정> MY플레이스 공식 블로그
    * @tag Mplace.placemy | 설정
    */
    'settings.blogmyplace': 'settings.blogmyplace',
    /**
    * @desc MY 설정 > 닫기
    * @tag Mplace.placemy | 설정
    */
    'settings.close': 'settings.close',
    /**
    * @desc MY 설정> 팔로우 차단/관리
    * @tag Mplace.placemy | 설정
    */
    'settings.follow': 'settings.follow',
    /**
    * @desc MY 설정> 로그아웃
    * @tag Mplace.placemy | 설정
    */
    'settings.logout': 'settings.logout',
    /**
    * @desc MY 설정> 네이버 지도앱 열기
    * @tag Mplace.placemy | 설정
    */
    'settings.mapopen': 'settings.mapopen',
    /**
    * @desc MY 설정> MY플레이스 스마트봇
    * @tag Mplace.placemy | 설정
    * @memo 25/1/22 추가
    */
    'settings.myplacesmartbot': 'settings.myplacesmartbot',
    /**
    * @desc MY 설정> 네이버 예약/주문 공지사항
    * @tag Mplace.placemy | 설정
    */
    'settings.noticebookingorder': 'settings.noticebookingorder',
    /**
    * @desc MY 설정> 플레이스 스마트봇
    * @tag Mplace.placemy | 설정
    */
    'settings.placesmartbot': 'settings.placesmartbot',
    /**
    * @desc MY 설정> 프로필 설정
    * @tag Mplace.placemy | 설정
    */
    'settings.profile': 'settings.profile',
    /**
    * @desc MY 설정> 네이버 예약/주문 톡톡친구
    * @tag Mplace.placemy | 설정
    */
    'settings.talkbookingorder': 'settings.talkbookingorder',
    /**
    * @desc MY 설정> MY플레이스 톡톡친구
    * @tag Mplace.placemy | 설정
    */
    'settings.talkmyplace': 'settings.talkmyplace',
    /**
    * @desc MY 설정 알림 팝업
    * @tag Mplace.placemy | 설정
    */
    'settingsalertpop': 'settingsalertpop',
    /**
    * @desc MY 설정 알림 팝업 > 예약/주문 알림 소식받기
    * @tag Mplace.placemy | 설정
    */
    'settingsalertpop.subscribebookingorder': 'settingsalertpop.subscribebookingorder',
    /**
    * @desc MY 설정 알림 팝업 > MY플레이스 알림 소식받기
    * @tag Mplace.placemy | 설정
    */
    'settingsalertpop.subscribemyplace': 'settingsalertpop.subscribemyplace',
    /**
    * @desc MY 설정 알림 팝업 > 예약/주문 알림 설정 취소
    * @tag Mplace.placemy | 설정
    */
    'settingsalertpop.subscribexbookingorder': 'settingsalertpop.subscribexbookingorder',
    /**
    * @desc MY 설정 알림 팝업 > MY플레이스 알림 설정 취소
    * @tag Mplace.placemy | 설정
    */
    'settingsalertpop.subscribexmyplace': 'settingsalertpop.subscribexmyplace',
    /**
    * @desc MY 설정 알림 팝업 > 예약/주문 소식받기 해제
    * @tag Mplace.placemy | 설정
    */
    'settingsalertpop.unsubscribebookingorder': 'settingsalertpop.unsubscribebookingorder',
    /**
    * @desc MY 설정 알림 팝업 > MY플레이스 소식받기 해제
    * @tag Mplace.placemy | 설정
    */
    'settingsalertpop.unsubscribemyplace': 'settingsalertpop.unsubscribemyplace',
    /**
    * @desc MY 설정 알림 팝업 > 예약/주문 알림 수신 해제 취소
    * @tag Mplace.placemy | 설정
    */
    'settingsalertpop.unsubscribexbookingorder': 'settingsalertpop.unsubscribexbookingorder',
    /**
    * @desc MY 설정 알림 팝업 > MY플레이스 알림 수신 해제 취소
    * @tag Mplace.placemy | 설정
    */
    'settingsalertpop.unsubscribexmyplace': 'settingsalertpop.unsubscribexmyplace',
    /**
    * @desc 타임라인페이지
    * @tag 타임라인 페이지 리스트 | Mplace.placemy
    */
    'timelinepg': 'timelinepg',
    /**
    * @desc 타임라인 > 뒤로가기
    * @tag 타임라인 페이지 지도뷰 | Mplace.placemy
    */
    'timelinepg.back': 'timelinepg.back',
    /**
    * @desc 다시 예약 버튼
    * @tag 타임라인 페이지 리스트 | Mplace.placemy
    */
    'timelinepg.book': 'timelinepg.book',
    /**
    * @desc 예약 내역 버튼
    * @tag 타임라인 페이지 리스트 | Mplace.placemy
    */
    'timelinepg.bookingdetails': 'timelinepg.bookingdetails',
    /**
    * @desc 예약 업커밍 타이틀
    * @tag 타임라인 페이지 리스트 | Mplace.placemy
    */
    'timelinepg.bookingtitle': 'timelinepg.bookingtitle',
    /**
    * @desc 타임라인 > 닫기
    * @tag 타임라인 페이지 지도뷰 | Mplace.placemy
    */
    'timelinepg.cancel': 'timelinepg.cancel',
    /**
    * @desc 취소한 내역 보기 선택
    * @tag 타임라인 페이지 리스트 | Mplace.placemy
    */
    'timelinepg.canceledevents': 'timelinepg.canceledevents',
    /**
    * @desc 카테고리 탭 선택 (전체)
    * @tag 타임라인 페이지 리스트 | Mplace.placemy
    */
    'timelinepg.categoryall': 'timelinepg.categoryall',
    /**
    * @desc 카테고리 탭 선택 (주문)
    * @tag 타임라인 페이지 리스트 | Mplace.placemy
    */
    'timelinepg.categoryorder': 'timelinepg.categoryorder',
    /**
    * @desc 카테고리 탭 선택 (승차권)
    * @tag 타임라인 페이지 리스트 | Mplace.placemy
    */
    'timelinepg.categorytrainticket': 'timelinepg.categorytrainticket',
    /**
    * @desc 카테고리 탭 선택 (예약)
    * @tag 타임라인 페이지 리스트 | Mplace.placemy
    */
    'timelinepg.categprybooking': 'timelinepg.categprybooking',
    /**
    * @desc 체크인 버튼
    * @tag 타임라인 페이지 리스트 | Mplace.placemy
    */
    'timelinepg.checkin': 'timelinepg.checkin',
    /**
    * @desc 상세 내역 링크
    * @tag 타임라인 페이지 리스트 | Mplace.placemy
    */
    'timelinepg.detailticketlink': 'timelinepg.detailticketlink',
    /**
    * @desc 다시 시도 버튼
    * @tag 타임라인 페이지 리스트 | Mplace.placemy
    */
    'timelinepg.errorrefresh': 'timelinepg.errorrefresh',
    /**
    * @desc 타임라인 상세 풀뷰
    * @tag 타임라인 페이지 지도뷰 | Mplace.placemy
    */
    'timelinepg.full': 'timelinepg.full',
    /**
    * @desc 타임라인 상세 하프뷰(Default)
    * @tag 타임라인 페이지 지도뷰 | Mplace.placemy
    */
    'timelinepg.half': 'timelinepg.half',
    /**
    * @desc 리스트 선택
    * @tag 타임라인 페이지 리스트 | Mplace.placemy
    */
    'timelinepg.list': 'timelinepg.list',
    /**
    * @desc 내역 삭제 버튼
    * @tag 타임라인 페이지 리스트 | Mplace.placemy
    */
    'timelinepg.listdelete': 'timelinepg.listdelete',
    /**
    * @desc 취소 버튼
    * @tag 타임라인 페이지 리스트 | Mplace.placemy
    */
    'timelinepg.listdeletecancel': 'timelinepg.listdeletecancel',
    /**
    * @desc 취소 버튼 (리뷰O)
    * @tag 타임라인 페이지 리스트 | Mplace.placemy
    */
    'timelinepg.listdeletecancelreview': 'timelinepg.listdeletecancelreview',
    /**
    * @desc 삭제 버튼
    * @tag 타임라인 페이지 리스트 | Mplace.placemy
    */
    'timelinepg.listdeletedelete': 'timelinepg.listdeletedelete',
    /**
    * @desc 삭제 버튼 (리뷰O)
    * @tag 타임라인 페이지 리스트 | Mplace.placemy
    */
    'timelinepg.listdeletedeletereview': 'timelinepg.listdeletedeletereview',
    /**
    * @desc 타임라인 > 현위치 버튼
    * @tag 타임라인 페이지 지도뷰 | Mplace.placemy
    */
    'timelinepg.location': 'timelinepg.location',
    /**
    * @desc 타임라인 지도 조작
    * @tag 타임라인 페이지 지도뷰 | Mplace.placemy
    */
    'timelinepg.mapmove': 'timelinepg.mapmove',
    /**
    * @desc 장소 마커 (일반)
    * @tag 타임라인 페이지 지도뷰 | Mplace.placemy
    */
    'timelinepg.markertl': 'timelinepg.markertl',
    /**
    * @desc 장소 마커 (사진)
    * @tag 타임라인 페이지 지도뷰 | Mplace.placemy
    */
    'timelinepg.markertlphoto': 'timelinepg.markertlphoto',
    /**
    * @desc 예약/주문 마커
    * @tag 타임라인 페이지 지도뷰 | Mplace.placemy
    */
    'timelinepg.markerupcoming': 'timelinepg.markerupcoming',
    /**
    * @desc 타임라인 상세 미니뷰
    * @tag 타임라인 페이지 지도뷰 | Mplace.placemy
    */
    'timelinepg.mini': 'timelinepg.mini',
    /**
    * @desc 더보기 버튼
    * @tag 타임라인 페이지 리스트 | Mplace.placemy
    */
    'timelinepg.more': 'timelinepg.more',
    /**
    * @desc 다시 주문 버튼
    * @tag 타임라인 페이지 리스트 | Mplace.placemy
    */
    'timelinepg.order': 'timelinepg.order',
    /**
    * @desc 주문 내역 버튼
    * @tag 타임라인 페이지 리스트 | Mplace.placemy
    */
    'timelinepg.orderdetails': 'timelinepg.orderdetails',
    /**
    * @desc 주문 업커밍 타이틀
    * @tag 타임라인 페이지 리스트 | Mplace.placemy
    */
    'timelinepg.ordertitle': 'timelinepg.ordertitle',
    /**
    * @desc 주문 유형 필터 칩(전체)
    * @tag 타임라인 페이지 리스트 | Mplace.placemy
    */
    'timelinepg.ordertypefilteall': 'timelinepg.ordertypefilteall',
    /**
    * @desc 주문 유형 필터 칩(배달)
    * @tag 타임라인 페이지 리스트 | Mplace.placemy
    */
    'timelinepg.ordertypefiltedelivery': 'timelinepg.ordertypefiltedelivery',
    /**
    * @desc 주문 유형 필터 칩(매장)
    * @tag 타임라인 페이지 리스트 | Mplace.placemy
    */
    'timelinepg.ordertypefiltedinein': 'timelinepg.ordertypefiltedinein',
    /**
    * @desc 주문유형 필터 칩(DT)
    * @tag 타임라인 페이지 리스트 | Mplace.placemy
    */
    'timelinepg.ordertypefiltedt': 'timelinepg.ordertypefiltedt',
    /**
    * @desc 주문 유형 필터 칩(포장)
    * @tag 타임라인 페이지 리스트 | Mplace.placemy
    */
    'timelinepg.ordertypefiltetakeout': 'timelinepg.ordertypefiltetakeout',
    /**
    * @desc 기간 필터
    * @tag 타임라인 페이지 리스트 | Mplace.placemy
    */
    'timelinepg.periodfilter': 'timelinepg.periodfilter',
    /**
    * @desc 기간 필터 모달 > 기간칩 선택 (1개월)
    * @tag 타임라인 페이지 리스트 | Mplace.placemy
    */
    'timelinepg.periodmodal1monthchip': 'timelinepg.periodmodal1monthchip',
    /**
    * @desc 기간 필터 모달 > 기간칩 선택 (1년)
    * @tag 타임라인 페이지 리스트 | Mplace.placemy
    */
    'timelinepg.periodmodal1yearchip': 'timelinepg.periodmodal1yearchip',
    /**
    * @desc 기간 필터 모달 > 기간칩 선택 (3개월)
    * @tag 타임라인 페이지 리스트 | Mplace.placemy
    */
    'timelinepg.periodmodal3monthschip': 'timelinepg.periodmodal3monthschip',
    /**
    * @desc 기간 필터 모달 > 기간칩 선택 (6개월)
    * @tag 타임라인 페이지 리스트 | Mplace.placemy
    */
    'timelinepg.periodmodal6monthschip': 'timelinepg.periodmodal6monthschip',
    /**
    * @desc 기간 필터 모달 > 뒤로가기
    * @tag 타임라인 페이지 리스트 | Mplace.placemy
    */
    'timelinepg.periodmodalback': 'timelinepg.periodmodalback',
    /**
    * @desc 업종 필터 칩 (레저,체험)
    * @tag 타임라인 페이지 리스트 | Mplace.placemy
    */
    'timelinepg.periodmodalbusinesstypeactivites': 'timelinepg.periodmodalbusinesstypeactivites',
    /**
    * @desc 업종 필터 칩 (전체)
    * @tag 타임라인 페이지 리스트 | Mplace.placemy
    */
    'timelinepg.periodmodalbusinesstypeall': 'timelinepg.periodmodalbusinesstypeall',
    /**
    * @desc 업종 필터 칩 (여행,명소)
    * @tag 타임라인 페이지 리스트 | Mplace.placemy
    */
    'timelinepg.periodmodalbusinesstypeattractions': 'timelinepg.periodmodalbusinesstypeattractions',
    /**
    * @desc 업종 필터 칩 (뷰티)
    * @tag 타임라인 페이지 리스트 | Mplace.placemy
    */
    'timelinepg.periodmodalbusinesstypebeauty': 'timelinepg.periodmodalbusinesstypebeauty',
    /**
    * @desc 업종 필터 칩 (카페)
    * @tag 타임라인 페이지 리스트 | Mplace.placemy
    */
    'timelinepg.periodmodalbusinesstypecafe': 'timelinepg.periodmodalbusinesstypecafe',
    /**
    * @desc 업종 필터 칩 (스포츠,오락)
    * @tag 타임라인 페이지 리스트 | Mplace.placemy
    */
    'timelinepg.periodmodalbusinesstypeentertainment': 'timelinepg.periodmodalbusinesstypeentertainment',
    /**
    * @desc 업종 필터 칩 (공연,전시)
    * @tag 타임라인 페이지 리스트 | Mplace.placemy
    */
    'timelinepg.periodmodalbusinesstypeevents': 'timelinepg.periodmodalbusinesstypeevents',
    /**
    * @desc 업종 필터 칩 (음식점)
    * @tag 타임라인 페이지 리스트 | Mplace.placemy
    */
    'timelinepg.periodmodalbusinesstypefood': 'timelinepg.periodmodalbusinesstypefood',
    /**
    * @desc 업종 필터 칩 (건강,의료)
    * @tag 타임라인 페이지 리스트 | Mplace.placemy
    */
    'timelinepg.periodmodalbusinesstypehealth': 'timelinepg.periodmodalbusinesstypehealth',
    /**
    * @desc 업종 필터 칩 (생활,편의)
    * @tag 타임라인 페이지 리스트 | Mplace.placemy
    */
    'timelinepg.periodmodalbusinesstypelife': 'timelinepg.periodmodalbusinesstypelife',
    /**
    * @desc 업종 필터 칩 (숙박)
    * @tag 타임라인 페이지 리스트 | Mplace.placemy
    */
    'timelinepg.periodmodalbusinesstypelodging': 'timelinepg.periodmodalbusinesstypelodging',
    /**
    * @desc 업종 필터 칩 (자연)
    * @tag 타임라인 페이지 리스트 | Mplace.placemy
    */
    'timelinepg.periodmodalbusinesstypenature': 'timelinepg.periodmodalbusinesstypenature',
    /**
    * @desc 업종 필터 칩 (기타)
    * @tag 타임라인 페이지 리스트 | Mplace.placemy
    */
    'timelinepg.periodmodalbusinesstypeothers': 'timelinepg.periodmodalbusinesstypeothers',
    /**
    * @desc 업종 필터 칩 (쇼핑,유통)
    * @tag 타임라인 페이지 리스트 | Mplace.placemy
    */
    'timelinepg.periodmodalbusinesstypeshopping': 'timelinepg.periodmodalbusinesstypeshopping',
    /**
    * @desc 업종 필터 칩 (장소대여)
    * @tag 타임라인 페이지 리스트 | Mplace.placemy
    */
    'timelinepg.periodmodalbusinesstypespacerental': 'timelinepg.periodmodalbusinesstypespacerental',
    /**
    * @desc 업종 필터 칩 (승차권)
    * @tag 타임라인 페이지 리스트 | Mplace.placemy
    */
    'timelinepg.periodmodalbusinesstypetrainticket': 'timelinepg.periodmodalbusinesstypetrainticket',
    /**
    * @desc 기간 필터 모달 > 나가기
    * @tag 타임라인 페이지 리스트 | Mplace.placemy
    */
    'timelinepg.periodmodalclose': 'timelinepg.periodmodalclose',
    /**
    * @desc 기간 필터 모달 > 기간 조회
    * @tag 타임라인 페이지 리스트 | Mplace.placemy
    */
    'timelinepg.periodmodaldone': 'timelinepg.periodmodaldone',
    /**
    * @desc 기간 필터 모달 > 종료일 선택 완료
    * @tag 타임라인 페이지 리스트 | Mplace.placemy
    */
    'timelinepg.periodmodalenddateconfirm': 'timelinepg.periodmodalenddateconfirm',
    /**
    * @desc 기간 필터 모달 > 종료일 선택
    * @tag 타임라인 페이지 리스트 | Mplace.placemy
    */
    'timelinepg.periodmodalenddateset': 'timelinepg.periodmodalenddateset',
    /**
    * @desc 기간 필터 모달 > 초기화
    * @tag 타임라인 페이지 리스트 | Mplace.placemy
    */
    'timelinepg.periodmodalreset': 'timelinepg.periodmodalreset',
    /**
    * @desc 기간 필터 모달 > 시작일 선택 완료
    * @tag 타임라인 페이지 리스트 | Mplace.placemy
    */
    'timelinepg.periodmodalstartdateconfirm': 'timelinepg.periodmodalstartdateconfirm',
    /**
    * @desc 기간 필터 모달 > 시작일 선택
    * @tag 타임라인 페이지 리스트 | Mplace.placemy
    */
    'timelinepg.periodmodalstartdateset': 'timelinepg.periodmodalstartdateset',
    /**
    * @desc 현 목록의 지도보기
    * @tag 타임라인 페이지 지도뷰 | Mplace.placemy
    */
    'timelinepg.reloadmap': 'timelinepg.reloadmap',
    /**
    * @desc 리뷰 스니핏
    * @tag 타임라인 페이지 리스트 | Mplace.placemy
    */
    'timelinepg.reviewfeedmy': 'timelinepg.reviewfeedmy',
    /**
    * @desc 리뷰쓰기 버튼
    * @tag 타임라인 페이지 리스트 | Mplace.placemy
    */
    'timelinepg.reviewwrite': 'timelinepg.reviewwrite',
    /**
    * @desc 장소 저장 추가
    * @tag 타임라인 페이지 리스트 | Mplace.placemy
    */
    'timelinepg.save': 'timelinepg.save',
    /**
    * @desc 최상단 버튼
    * @tag 타임라인 페이지 리스트 | Mplace.placemy
    */
    'timelinepg.scolltotop': 'timelinepg.scolltotop',
    /**
    * @desc 리스트 내 스크롤
    * @tag 타임라인 페이지 지도뷰 | Mplace.placemy
    * @memo rank: 10
    */
    'timelinepg.scrlist': 'timelinepg.scrlist',
    /**
    * @desc 리스트 내 스크롤 추가호출
    * @tag 타임라인 페이지 지도뷰 | Mplace.placemy
    */
    'timelinepg.scrmorelist': 'timelinepg.scrmorelist',
    /**
    * @desc 리스트시트 스와이프 다운
    * @tag 타임라인 페이지 지도뷰 | Mplace.placemy
    */
    'timelinepg.swdlist': 'timelinepg.swdlist',
    /**
    * @desc 리스트시트 스와이프 업
    * @tag 타임라인 페이지 지도뷰 | Mplace.placemy
    */
    'timelinepg.swulist': 'timelinepg.swulist',
    /**
    * @desc 승차권 업커밍 타이틀
    * @tag 타임라인 페이지 리스트 | Mplace.placemy
    */
    'timelinepg.traintickettitle': 'timelinepg.traintickettitle',
    /**
    * @desc 장소 저장 해제
    * @tag 타임라인 페이지 리스트 | Mplace.placemy
    */
    'timelinepg.unsave': 'timelinepg.unsave',
    /**
    * @desc 예약 내역
    * @tag 타임라인 페이지 리스트 | Mplace.placemy
    */
    'timelinepg.upcomingbookingdetails': 'timelinepg.upcomingbookingdetails',
    /**
    * @desc 업커밍 카드 선택
    * @tag 타임라인 페이지 리스트 | Mplace.placemy
    */
    'timelinepg.upcomingcardclick': 'timelinepg.upcomingcardclick',
    /**
    * @desc 길찾기
    * @tag 타임라인 페이지 리스트 | Mplace.placemy
    */
    'timelinepg.upcomingdirection': 'timelinepg.upcomingdirection',
    /**
    * @desc 길찾기
    * @tag 타임라인 페이지 리스트 | Mplace.placemy
    */
    'timelinepg.upcomingdirectionicon': 'timelinepg.upcomingdirectionicon',
    /**
    * @desc 새로고침
    * @tag 타임라인 페이지 리스트 | Mplace.placemy
    */
    'timelinepg.upcomingrefresh': 'timelinepg.upcomingrefresh',
    /**
    * @desc 업커밍 카드 펼쳐서 더보기
    * @tag 타임라인 페이지 리스트 | Mplace.placemy
    */
    'timelinepg.upcomingviewmore': 'timelinepg.upcomingviewmore',
    /**
    * @desc 지도보기
    * @tag 타임라인 페이지 지도뷰 | Mplace.placemy
    */
    'timelinepg.viewmap': 'timelinepg.viewmap',
};
